import React, { useEffect, useState, useRef } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";

import styles from "./styles";
import FullPageLayout from "../../layouts/FullPage";
import LoginForm2 from "./LoginForm2";
import BuildInfo from "./BuildInfo";

import backgroundImage from "./schedule1_shrunk.jpg";

import {
  authActions,
  userSettingsActions,
  isLoggingIn,
  getAuthError,
  isAuthenticated,
  getCurrentUser,
  getHostAgency,
} from "../../reducers";

const useStyles = makeStyles(styles);

const Login = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const isLoading = useSelector(isLoggingIn);
  const error = useSelector(getAuthError);
  const [needsErrorRedirect, setneedsErrorRedirect] = useState(false);
  const authenticated = useSelector(isAuthenticated);
  const currentUser = useSelector(getCurrentUser);
  const hostAgency = useSelector(getHostAgency);
  const [newUserLoaded, setNewUserLoaded] = useState(false);
  const [timeOffsetLoaded, setTimeOffsetLoaded] = useState(false);
  const [durationIncrementLoaded, setDurationIncrementLoaded] = useState(false);
  const isMountedRef = useRef(null);
  const classes = useStyles();

  const handleLogin = (values) => {
    const { username, password } = values;
    dispatch(authActions.login(username, password));
  };

  useEffect(() => {
    const checkError = (error) => {
      if (error !== null && error !== undefined) {
        if (error.includes("reset")) {
          setneedsErrorRedirect(true);
        }
      }
    };
    checkError(error);
    return () => {
      setneedsErrorRedirect(false);
    };
  }, [error, dispatch, needsErrorRedirect]);

  useEffect(() => {
    isMountedRef.current = true;
    const getSettings = async (id) => {
      try {
        const settings = await dispatch(userSettingsActions.fetchSettings(id));
        setNewUserLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };
    const getTimeZoneSettings = async () => {
      try {
        const timeZoneSettings = await dispatch(
          userSettingsActions.fetchAppSettings(36)
        );
        setTimeOffsetLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };

    const getAppSettings = async () => {
      try {
        const appSettings = await dispatch(
          userSettingsActions.fetchAppSettings(376)
        );

        setDurationIncrementLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };

    if (authenticated && isMountedRef.current === true) {
      getSettings(currentUser.id);
      getTimeZoneSettings();
      getAppSettings();
    }
    return () => {
      setNewUserLoaded(false);
      setDurationIncrementLoaded(false);
      setTimeOffsetLoaded(false);
      isMountedRef.current = false;
    };
  }, [currentUser, authenticated, dispatch]);

  if (
    authenticated &&
    currentUser !== null &&
    newUserLoaded &&
    timeOffsetLoaded &&
    durationIncrementLoaded
  ) {
    return state && state.from ? (
      <Redirect to={state.from} />
    ) : (
      <Redirect to="/" />
    );
  }

  return (
    <FullPageLayout
      backgroundImage={backgroundImage}
      photoCredit={<BuildInfo />}
    >
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={8} md={5}>
            <LoginForm2
              hostAgency={hostAgency}
              onLogin={handleLogin}
              error={error}
              isLoading={isLoading}
              redirect={needsErrorRedirect}
            />
          </GridItem>
        </GridContainer>
      </div>
    </FullPageLayout>
  );
};

export default Login;
